export default {
  APP: {
    NAME: 'Brokers',
    COMPANY: 'Freightforge'
  },
  ACTIONS: {
    ACCEPT: 'Accept',
    ADD: 'Create',
    APPLY: 'Apply',
    RETRY: 'Retry',
    CLEAR: 'Clear',
    CANCEL: 'Cancel',
    INSTALL: 'Install',
    CLOSE: 'Close',
    LOG_OUT: 'Log out',
    IS_LOADING: 'Loading ...'
  },
  EQUIPMENT_TYPES: {
    V: 'Dry Van',
    F: 'Flatbed',
    R: 'Reefer',
    LT: 'Liquidity Totes',
    LB: 'Lowboy',
    HS: 'Hotshot',
    CV: 'Curtain van',
    V_V: 'Vented Van',
    F_S: 'Flat + Sides',
    TNK: 'Tank',
    CONT: 'Container',
    PNEU: 'Pneumatic',
    F_T: 'Flat + Tarp',
    BT: 'Box truck',
    C: 'Conestoga',
    PO: 'Power only',
    LA: 'Landall',
    DT: 'Dump trailer',
    CRG: 'Cargo van',
    MX: 'Maxi flat',
    AC: 'Auto Carrier',
    DD: 'Double drop',
    HB: 'Hopper bottom',
    VINT: 'Van - intermodal',
    FINT: 'Flat - intermodal',
    RINT: 'Reefer - intermodal',
    SD: 'Step deck',
    RGN: 'Removable gooseneck',
    SPEC: 'Special commodity'
  },
  PACKAGING_TYPES: {
    BOX: 'Box',
    PALLET: 'Pallet',
    CONTAINER: 'Container',
    BULK: 'Bulk',
    OVERSIZED: 'Oversized',
    LINEAR: 'Linear Feet',
    SLIPSHEET: 'Slip Sheet'
  },
  DATE: {
    YESTERDAY: 'Yesterday',
    TODAY: 'Today',
    TOMORROW: 'Tomorrow'
  },
  OFFLINE: {
    IS_OFFLINE: {
      SHORT: 'Offline'
    }
  },
  QUOTES_LIST: {
    TITLE: '@:APP.NAME',
    FILTERS: {
      TITLE: 'Filter by'
    },
    SORTS: {
      TITLE: 'Sort by'
    },
    ERRORS: {
      GET: {
        LABEL: 'Oups !',
        DESCRIPTION: 'Failed to retrieve quotes, please retry in a few moment.'
      },
      NOTHING_TO_SEE: {
        LABEL: 'No result',
        DESCRIPTION: ''
      }
    }
  },
  QUOTES_DETAIL: {
    TITLE: 'Details',
    ERRORS: {
      NOTHING_TO_SEE: {
        LABEL: 'No result'
      }
    },
    EXPECTED_AMOUNT: {
      TITLE: 'Expected amount'
    },
    EQUIPMENT_TYPE: {
      TITLE: 'Equipment',
      V: '@:EQUIPMENT_TYPES.V',
      F: '@:EQUIPMENT_TYPES.F',
      R: '@:EQUIPMENT_TYPES.R',
      LT: '@:EQUIPMENT_TYPES.LT',
      LB: '@:EQUIPMENT_TYPES.LB',
      HS: '@:EQUIPMENT_TYPES.HS',
      CV: '@:EQUIPMENT_TYPES.CV',
      V_V: '@:EQUIPMENT_TYPES.V_V',
      F_S: '@:EQUIPMENT_TYPES.F_S',
      TNK: '@:EQUIPMENT_TYPES.TNK',
      CONT: '@:EQUIPMENT_TYPES.CONT',
      PNEU: '@:EQUIPMENT_TYPES.PNEU',
      F_T: '@:EQUIPMENT_TYPES.F_T',
      BT: '@:EQUIPMENT_TYPES.BT',
      C: '@:EQUIPMENT_TYPES.C',
      PO: '@:EQUIPMENT_TYPES.PO',
      LA: '@:EQUIPMENT_TYPES.LA',
      DT: '@:EQUIPMENT_TYPES.DT',
      CRG: '@:EQUIPMENT_TYPES.CRG',
      MX: '@:EQUIPMENT_TYPES.MX',
      AC: '@:EQUIPMENT_TYPES.AC',
      DD: '@:EQUIPMENT_TYPES.DD',
      HB: '@:EQUIPMENT_TYPES.HB',
      VINT: '@:EQUIPMENT_TYPES.VINT',
      FINT: '@:EQUIPMENT_TYPES.FINT',
      RINT: '@:EQUIPMENT_TYPES.RINT',
      SD: '@:EQUIPMENT_TYPES.SD',
      RGN: '@:EQUIPMENT_TYPES.RGN',
      SPEC: '@:EQUIPMENT_TYPES.SPEC'
    },
    PACKAGING_TYPE: {
      TITLE: 'Packaging',
      BOX: '@:PACKAGING_TYPES.BOX',
      PALLET: '@:PACKAGING_TYPES.PALLET',
      CONTAINER: '@:PACKAGING_TYPES.CONTAINER',
      BULK: '@:PACKAGING_TYPES.BULK',
      OVERSIZED: '@:PACKAGING_TYPES.OVERSIZED',
      LINEAR: '@:PACKAGING_TYPES.LINEAR',
      SLIPSHEET: '@:PACKAGING_TYPES.SLIPSHEET'
    },
    WEIGHT: {
      TITLE: 'Weight'
    },
    PICKUP: {
      TITLE: 'Pickup'
    },
    DELIVERY: {
      TITLE: 'Delivery'
    },
    RATE_RESPONSE: {
      TITLE: 'Rate responses'
    },
    PROMPT: 'Sure ?'
  },
  QUOTES_LIST_SORTS_FIELDS: {
    PICKUP: {
      EARLIEST_DATE: {
        TITLE: 'Earliest Pickup Date'
      }
    },
    DELIVERY: {
      EARLIEST_DATE: {
        TITLE: 'Earliest Delivery Date'
      }
    },
    DEADLINE: {
      TITLE: 'Deadline Date'
    }
  },
  QUOTES_LIST_RESUME: {
    EQUIPMENT_TYPE: {
      V: '@:EQUIPMENT_TYPES.V',
      F: '@:EQUIPMENT_TYPES.F',
      R: '@:EQUIPMENT_TYPES.R',
      LT: '@:EQUIPMENT_TYPES.LT',
      LB: '@:EQUIPMENT_TYPES.LB',
      HS: '@:EQUIPMENT_TYPES.HS',
      CV: '@:EQUIPMENT_TYPES.CV',
      V_V: '@:EQUIPMENT_TYPES.V_V',
      F_S: '@:EQUIPMENT_TYPES.F_S',
      TNK: '@:EQUIPMENT_TYPES.TNK',
      CONT: '@:EQUIPMENT_TYPES.CONT',
      PNEU: '@:EQUIPMENT_TYPES.PNEU',
      F_T: '@:EQUIPMENT_TYPES.F_T',
      BT: '@:EQUIPMENT_TYPES.BT',
      C: '@:EQUIPMENT_TYPES.C',
      PO: '@:EQUIPMENT_TYPES.PO',
      LA: '@:EQUIPMENT_TYPES.LA',
      DT: '@:EQUIPMENT_TYPES.DT',
      CRG: '@:EQUIPMENT_TYPES.CRG',
      MX: '@:EQUIPMENT_TYPES.MX',
      AC: '@:EQUIPMENT_TYPES.AC',
      DD: '@:EQUIPMENT_TYPES.DD',
      HB: '@:EQUIPMENT_TYPES.HB',
      VINT: '@:EQUIPMENT_TYPES.VINT',
      FINT: '@:EQUIPMENT_TYPES.FINT',
      RINT: '@:EQUIPMENT_TYPES.RINT',
      SD: '@:EQUIPMENT_TYPES.SD',
      RGN: '@:EQUIPMENT_TYPES.RGN',
      SPEC: '@:EQUIPMENT_TYPES.SPEC'
    },
    PACKAGING_TYPE: {
      BOX: '@:PACKAGING_TYPES.BOX',
      PALLET: '@:PACKAGING_TYPES.PALLET',
      CONTAINER: '@:PACKAGING_TYPES.CONTAINER',
      BULK: '@:PACKAGING_TYPES.BULK',
      OVERSIZED: '@:PACKAGING_TYPES.OVERSIZED',
      LINEAR: '@:PACKAGING_TYPES.LINEAR',
      SLIPSHEET: '@:PACKAGING_TYPES.SLIPSHEET'
    }
  },
  QUOTES_DETAIL_LOCATION_AND_DATE: {
    IS_NOT_FLEXIBLE: 'Not flexible'
  },
  TYPES_CHECKBOX: {
    V: '@:EQUIPMENT_TYPES.V',
    F: '@:EQUIPMENT_TYPES.F',
    R: '@:EQUIPMENT_TYPES.R',
    LT: '@:EQUIPMENT_TYPES.LT',
    LB: '@:EQUIPMENT_TYPES.LB',
    HS: '@:EQUIPMENT_TYPES.HS',
    CV: '@:EQUIPMENT_TYPES.CV',
    V_V: '@:EQUIPMENT_TYPES.V_V',
    F_S: '@:EQUIPMENT_TYPES.F_S',
    TNK: '@:EQUIPMENT_TYPES.TNK',
    CONT: '@:EQUIPMENT_TYPES.CONT',
    PNEU: '@:EQUIPMENT_TYPES.PNEU',
    F_T: '@:EQUIPMENT_TYPES.F_T',
    BT: '@:EQUIPMENT_TYPES.BT',
    C: '@:EQUIPMENT_TYPES.C',
    PO: '@:EQUIPMENT_TYPES.PO',
    LA: '@:EQUIPMENT_TYPES.LA',
    DT: '@:EQUIPMENT_TYPES.DT',
    CRG: '@:EQUIPMENT_TYPES.CRG',
    MX: '@:EQUIPMENT_TYPES.MX',
    AC: '@:EQUIPMENT_TYPES.AC',
    DD: '@:EQUIPMENT_TYPES.DD',
    HB: '@:EQUIPMENT_TYPES.HB',
    VINT: '@:EQUIPMENT_TYPES.VINT',
    FINT: '@:EQUIPMENT_TYPES.FINT',
    RINT: '@:EQUIPMENT_TYPES.RINT',
    SD: '@:EQUIPMENT_TYPES.SD',
    RGN: '@:EQUIPMENT_TYPES.RGN',
    SPEC: '@:EQUIPMENT_TYPES.SPEC',
    BOX: '@:PACKAGING_TYPES.BOX',
    PALLET: '@:PACKAGING_TYPES.PALLET',
    CONTAINER: '@:PACKAGING_TYPES.CONTAINER',
    BULK: '@:PACKAGING_TYPES.BULK',
    OVERSIZED: '@:PACKAGING_TYPES.OVERSIZED',
    LINEAR: '@:PACKAGING_TYPES.LINEAR',
    SLIPSHEET: '@:PACKAGING_TYPES.SLIPSHEET'
  },
  EQUIPMENT_TYPES_CHECKBOX: {
    TITLE: 'Equipment'
  },
  PACKAGING_TYPES_CHECKBOX: {
    TITLE: 'Packaging'
  },
  PICKUP_REGIONS_SELECT: {
    TITLE: 'Pickup'
  },
  DELIVERY_REGIONS_SELECT: {
    TITLE: 'Delivery'
  },
  QUOTES_LIST_FILTERS_FIELDS: {
    TITLE: 'Rate request',
    RESPONDED: {
      TITLE: 'Responded'
    },
    MANAGEABLE: {
      TITLE: 'Manageable'
    }
  },
  PWA_INSTALLER: {
    TITLE: '@:ACTIONS.INSTALL @:APP.NAME of @:APP.COMPANY on your mobile'
  },
  CONNECTED_USER: {
    ERRORS: {
      GET: 'Failed to retrieve connected user',
      LOG_OUT: 'Failed to log out'
    }
  },
  STATE_ALERT: {
    OPEN: 'Opened',
    PENDING: 'Pending',
    ALLOCATED: 'Allocated',
    EXECUTED: 'Executed',
    CANCELED: 'Canceled'
  }
}
